import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";
import _, { debounce } from "lodash";

import {LoadingIcon} from '../../../Common/Loading_Icon';
import colours from '../../../Common/DesignSystem/Colours';
import { constants } from '../../../../Helpers/Constants';
import { setList, setOverlay } from '../../../../Actions/stakeholderActions'

import Select from 'react-select';
import { Trans } from 'react-i18next';
import { DropdownItem, Input } from '../../../Common/DesignSystem/Input';
import DatePicker from '../../../Common/DatePicker';
import PopupModal from '../../../Common/DesignSystem/PopupModal';
import { InputLabel, P3Bold } from '../../../Common/DesignSystem/Text';
import Button from '../../../Common/DesignSystem/Button';
import { SelectedVehicleCard } from '../../../Common/DesignSystem/VehicleResultCard';

let  category_options = [{label:'Service', value: 0},{label:'Insurance', value: 1}, {label:'License', value: 2},{label:'Termination', value: 3},];

class VehicleReminderOverlay extends Component {

    constructor(props) {    
        super(props);

        this.state = {
            reminder_details: {},
            action: "",
            loading_page: true,
            vehicles: {},
            previous_form: {vehicle: null, category: null, date: null, km: null},
            reminder_form: {vehicle: null, category: null, date: null, km: null},
            errors: {date: '', km: ''}
        };

        this.submitForm = debounce(this.submitForm.bind(this), 500);
        this.updateForm = this.updateForm.bind(this);
        this.updateVehicle = this.updateVehicle.bind(this);
        this.updateCategory = this.updateCategory.bind(this);
        this.checkChanged = this.checkChanged.bind(this);
        this.close = this.close.bind(this);
    }

    componentDidMount() {
        var self = this;
        if(this.props.match.params.action === undefined) {
            axios.get( "ajax/vehicle/" + this.props.match.params.v_id + "/reminder/create")
            .then(function(response) {
                let temp_form = {
                    vehicle: response?.data.view.vehicle,
                    category: response?.data.view.category,
                    date: response?.data.view.date,
                    km: response?.data.view.km
                }

                if(response?.data.view.vehicle == "" && response?.data.vehicles.length == 1)
                {
                    temp_form.vehicle = response?.data.vehicles[0].V_ID;
                    temp_form.category = 0;
                }

                self.setState({
                    reminder_details: response?.data.view,
                    vehicles: response?.data.vehicles,
                    loading_page: false,
                    previous_form: Object.assign({}, temp_form),
                    reminder_form: temp_form,
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        } else if(this.props.match.params.reminder_id !== undefined) {
            axios.get( "ajax/reminder/" + this.props.match.params.reminder_id + "/edit")
            .then(function(response) {
                self.state.reminder_form.vehicle = response?.data.view.vehicle;
                self.state.reminder_form.category = response?.data.view.category;
                self.state.reminder_form.date = moment(response?.data.view.date, 'YYYY-MM-DD').format('MMM DD, YYYY');
                self.state.reminder_form.km = response?.data.view.km;
                let temp_form = {
                    vehicle: response?.data.view.vehicle,
                    category: response?.data.view.category,
                    date: moment(response?.data.view.date).format('MM-DD-YYYY'),
                    km: response?.data.view.km
                }

                if(response?.data.view.vehicle == "" && response?.data.vehicles.length == 1)
                {
                    temp_form.vehicle = response?.data.vehicles[0].V_ID;
                    temp_form.category = 0;
                }

                self.setState({
                    reminder_details: response?.data.view,
                    vehicles: response?.data.vehicles,
                    loading_page: false,
                    previous_form: Object.assign({}, temp_form),
                    reminder_form: temp_form,
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        }
    }

    submitForm(event) {
        event.preventDefault();
        var self = this;
        var url = '/ajax/reminder';

        if(this.state.reminder_details.primary_button_action == 'update') {
            url = '/ajax/reminder/' + this.props.match.params.reminder_id + '/update';
        }

        let form_final = this.state.reminder_form;
        form_final['date'] = (moment(this.state.reminder_form.date).isValid() ? moment(this.state.reminder_form.date).format('YYYY-MM-DD') : '');

        axios({
            method: 'post',
            url: url,
            data: form_final,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then(function (response) {
            //handle success
            axios.get('/ajax/dashboard/overdueReminders')
            .then(function(response2) {
                self.props.dispatch(setList("SET_VEHICLE_REMINDER_LIST", response2.data.reminders.active))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })

            if ("vehicle" in self.props.stakeholder.current_vehicle_details && self.state.reminder_form.vehicle === self.props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                axios.get('/ajax/vehicle/' + self.state.reminder_form.vehicle)
                .then(function(response2) {
                    self.props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            showStatusMsg(response?.data.message, 'success');
            self.props.history.goBack();
        })
        .catch(function (error) {
            //handle error
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                let response = error.response;
                let date_err = '';
                let km_err = '';

                if (response?.data.errors.date?.length > 0)
                    date_err = response?.data.errors.date[0];
                if (response?.data.errors.km?.length > 0)
                    km_err = response?.data.errors.km[0];

                self.setState({errors: {date: date_err, km: km_err}})
            } else {
                showStatusMsg("Requested information not found");
            }
        });
    }

    updateForm(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var reminder_form = this.state.reminder_form;
        reminder_form[name] = value;

        this.setState({
            reminder_form: reminder_form,
        });
    }

    updateVehicle(option) {
        reminder_form["vehicle"] = option.value;

        this.setState({
            reminder_form: reminder_form
        });
    }

    updateCategory(option) {
        var reminder_form = this.state.reminder_form;
        reminder_form["category"] = option.value;

        this.setState({
            reminder_form: reminder_form,
        });
    }

    checkChanged() {
        if (_.isEqual(this.state.reminder_form, this.state.previous_form))
            return false;
        return true;
    }

    close() {
        this.checkChanged() ?
        confirm('Discard changes? Your reminder will not be saved.') ?
            this.props.history.goBack()
        : null
    : this.props.history.goBack()
    }

    render(props) {
        if(!this.state.loading_page) {
            return (
                <PopupModal 
                    headerText={this.props.match.params.reminder_id !== undefined ? "Edit Vehicle Reminder" : "Add Vehicle Reminder"}
                    close={()=> {
                        this.close();
                    }}
                    content={
                        <div id="vehiclereminder-overlay" style={{width: '100%'}}>
                            <div>
                                <div id="vehicle_field" style={{width: '100%', display: 'flex', flexDirection: 'column', flex: 1, position: 'relative', display: 'inline-block'}}>
                                    <div>
                                        <div style={{marginLeft: 16, marginBottom: 4, display: 'flex', flexDirection: 'row'}}>
                                            <InputLabel><Trans>Vehicle</Trans></InputLabel>
                                        </div>
                                        <SelectedVehicleCard 
                                            vehicle={this.state.vehicles[0]}/>
                                    </div>
                                </div>
                                <div style={{width: '100%', display: 'flex', flexDirection: 'column', flex: 1, position: 'relative', display: 'inline-block', overflow: 'visible', marginTop: 16}}>
                                    <div>
                                        <Input 
                                            label="Type"
                                            dropdown
                                            required
                                            name="oem_id"
                                            value={this.state.reminder_form.category}
                                            dropdownLabel={category_options.find(obj => obj.value == this.state.reminder_form.category)?.label }
                                            onChange={(e)=> {this.updateCategory({value: e.currentTarget.dataset.id})}}>
                                                {category_options.map(opt =>
                                                    <DropdownItem key={opt.label} label={opt.label} value={opt.value}/>
                                                )}
                                        </Input>
                                    </div>
                                </div>
                                <div className = "row expanded collapse mb-8">
                                    <div className = "columns large-6 medium-6 small-12">
                                        <div className='mr-8-desktop'>
                                            <Input
                                                datepicker
                                                value={this.state.reminder_form.date == 'Invalid date' ? '' : this.state.reminder_form.date}
                                                name="date"
                                                onChange={(val) => {
                                                    if (moment(val.target.value).isValid() && moment(val.target.value).isSameOrBefore(moment())) {
                                                        let temp = this.state.errors;
                                                        temp.date = "Date must be in the future";
                                                        this.updateForm(val);
                                                        this.setState({ errors: temp });
                                                    }  else {
                                                        let temp = this.state.errors;
                                                        temp.date = '';
                                                        this.updateForm(val);
                                                        this.setState({ errors: temp });
                                                    }
                                                }}
                                                label="Date Reminder"
                                                id="reminder_date"
                                                message={this.state.errors.date}
                                                variant={this.state.errors.date ? "error" : ""}
                                                disabled={false}
                                                placeholder="MM-DD-YYYY"
                                                trailing_ic="Calendar" 
                                                trailing_ic_style={{color: colours.primary.grey03}}
                                            />
                                        </div>
                                    </div>
                                    <div className = "columns large-6 medium-6 small-12">
                                        <div className='ml-8-desktop'>
                                            <Input 
                                                name="km"
                                                label="KM Reminder"
                                                trailing_ic_rawText
                                                trailing_ic="KM"
                                                onChange={(val) => {
                                                    this.updateForm(val);
                                                    let errors = this.state.errors;
                                                    errors['km'] = '';
                                                    this.setState({errors});
                                                }}
                                                value={this.state.reminder_form.km}
                                                placeholder="Enter KM"
                                                variant={this.state.errors.km ? "error" : ""}
                                                message={this.state.errors.km}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className = "card-button-section">
                                <div style={{display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'center', alignItems: 'center'}}>
                                        <Button 
                                            label='Cancel' 
                                            secondary 
                                            large 
                                            onClick={this.props.history.goBack} 
                                            containerProps={{style: {display: 'flex' , flex: 1, maxWidth: '172px'}}} 
                                            style={{flex: 1}}/>
                                        <div style={{width: '24px'}}></div>
                                        <Button 
                                            label='Save' 
                                            large 
                                            disabled={this.state.errors.km || this.state.errors.date}
                                            onClick={this.submitForm} 
                                            containerProps={{style: {display: 'flex' , flex: 1, maxWidth: '172px'}}} 
                                            style={{flex: 1}}/>
                                </div>
                            </div>
                        </div>
                    }
            />
            );
        } else {
            return (
                <LoadingIcon />
            );
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(VehicleReminderOverlay)